import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Creatable} from 'react-select';
import Popup from '../../../common/Popup';
import * as docketActions from '../../../../redux/actions/docketActions';
import loadingSpinnerImage from '../../../../images/loadingSpinner.gif';
import ProgressBar from '../../../common/ProgressBar/ProgressBar';

const selectStyle = {  };

class EmailPartPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      selectedEmails: [],
      hasInvalidEmail: true,
    };
  }

  componentDidMount() {
    this.props.dispatch(docketActions.loadFavoriteEmails());
    this.props.dispatch(docketActions.loadLastFavoriteEmails());
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.favoriteEmails.lastRecipients !== prevProps.favoriteEmails.lastRecipients) {
      this.setState({
        selectedEmails: this.props.favoriteEmails.lastRecipients.map(email => ({ value: email, label: email })),
        hasInvalidEmail: this.props.favoriteEmails.lastRecipients.length <= 0,
      });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { selectedEmails, text } = this.state;
    const hasInvalidEmail = selectedEmails.find(email => !/\S+@\S+\.\S+/.test(email.value));

    if (!!hasInvalidEmail) {
      this.setState({ hasInvalidEmail: hasInvalidEmail.value });
      return;
    }

    const params = {
      ...this.props.popup.data,
      email_address: selectedEmails.map(e => e.value).join(','),
      email_message: text,
    };

    this.props.dispatch(docketActions.sendEmail(params))
      .then(this.props.reloadDetails);
  };

  handleTextChange = (e) => {
    e.preventDefault();
    this.setState({ text: e.target.value });
  };

  handleChange = selectedEmails => {
    this.setState({
      selectedEmails,
      hasInvalidEmail: !(selectedEmails && selectedEmails.length > 0),
    });
  };

  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  );

  render() {
    const isLoading = this.props.favoriteEmails.status === 'loading';
    const options = this.props.favoriteEmails.emails.map(email => ({ value: email, label: email }));
    const { hasInvalidEmail } = this.state;

    return (
      <Popup show={this.props.popup.show}
             clsName="email-popup"
             topBarTitle="Email Combined PDFs"
             onClose={this.props.onClose}>
        <div className="inner-text">
          <div>
            <div>
              <label htmlFor="email">Emails</label>
              <br />
              <Creatable
                name="email"
                style={selectStyle}
                isLoading={isLoading}
                multi
                options={options}
                value={this.state.selectedEmails}
                onChange={this.handleChange}
              />
              {hasInvalidEmail && hasInvalidEmail.length &&
                <span className="error">Please enter a valid email</span>
              }
            </div>
            <p>
              <label htmlFor="email">Message (optional)</label>
              <br />
              <textarea name="message"
                        rows="5"
                        cols="50"
                        onChange={this.handleTextChange}
                        value={this.state.text} />
            </p>
          </div>

          { isLoading &&
            <div>
              <img src={loadingSpinnerImage} />
            </div>
          }

        </div>

        <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div className="ui-dialog-buttonset">
            <button type="button" onClick={this.props.onClose}>Cancel</button>
            <button type="button" onClick={this.onSubmit} disabled={hasInvalidEmail}>Send</button>
          </div>
        </div>
      </Popup>
    );
  }
}

EmailPartPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  favoriteEmails: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, favoriteEmails } = state.get('dockets').toJS();

  return {
    popup,
    favoriteEmails,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailPartPopup);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailPartPopup.jsx